import Breadcrumb from '../components/Breadcrumb'
import complaintsPdf from '../assets/compliance/gaiapowered-complaints-and-feedback-procedure.pdf'
import trustmarkCharterPdf from '../assets/compliance/trustmark-customer-charter.pdf'
import trustmarkLogo from '../assets/images/trustmark-logo-white.svg'

const CustomerCare = () => {
  const breadcrumbItems = [
    { label: 'Home', path: '/' },
    { label: 'Customer Care' }
  ]

  return (
    <div className="min-h-screen bg-white">
      <section className="bg-gradient-to-r from-dark-background to-dark-plum text-white py-12">
        <div className="container-custom">
          <Breadcrumb
            items={breadcrumbItems}
            className="mb-6 text-gray-300"
          />
          <div className="max-w-3xl">
            <h1 className="text-3xl md:text-4xl font-bold mb-4 text-white">
              Customer Care
            </h1>
            <p className="text-xl text-gray-200">
              Our accreditations, insurance, and customer support information
            </p>
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto space-y-12">

            {/* Company Details */}
            <div>
              <h2 className="text-2xl font-semibold text-dark-plum mb-6">Company Details</h2>
              <div className="bg-gray-50 rounded-xl p-6 space-y-3 text-gray-700">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3">
                  <div>
                    <span className="font-semibold text-dark-plum">Business name</span>
                    <p>Gaia Powered Limited</p>
                  </div>
                  <div>
                    <span className="font-semibold text-dark-plum">Company number</span>
                    <p>16126166</p>
                  </div>
                  <div>
                    <span className="font-semibold text-dark-plum">VAT number</span>
                    <p>485096946</p>
                  </div>
                  <div>
                    <span className="font-semibold text-dark-plum">MCS certificate</span>
                    <p>NAP/78176/25/1</p>
                  </div>
                  <div>
                    <span className="font-semibold text-dark-plum">Registered address</span>
                    <p>124 City Road, London, United Kingdom, EC1V 2NX</p>
                  </div>
                  <div>
                    <span className="font-semibold text-dark-plum">Contact</span>
                    <p>
                      <a href="tel:02046007511" className="text-primary-green hover:underline">
                        020 4600 7511
                      </a>
                    </p>
                    <p>
                      <a href="mailto:sales@gaiapowered.co.uk" className="text-primary-green hover:underline">
                        sales@gaiapowered.co.uk
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Insurance */}
            <div>
              <h2 className="text-2xl font-semibold text-dark-plum mb-6">Insurance</h2>
              <div className="space-y-4">
                {[
                  {
                    label: 'Public liability',
                    coverage: '£5 million',
                    provider: 'Covéa Insurance plc',
                    policy: 'BAC12662072298',
                  },
                  {
                    label: 'Employers\' liability',
                    coverage: '£10 million',
                    provider: 'Covéa Insurance plc',
                    policy: 'BAC12662072298',
                  },
                  {
                    label: 'Professional indemnity',
                    coverage: '£1 million',
                    provider: 'AXA XL Insurance Company UK Limited, via Aqueous Underwriting',
                    policy: 'P251PA0008717',
                  },
                ].map(({ label, coverage, provider, policy }) => (
                  <div
                    key={label}
                    className="bg-gray-50 rounded-xl p-5 grid grid-cols-1 sm:grid-cols-4 gap-2"
                  >
                    <div>
                      <p className="text-xs text-gray-400 uppercase tracking-wide mb-0.5">Type</p>
                      <p className="font-semibold text-dark-plum">{label}</p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-400 uppercase tracking-wide mb-0.5">Coverage</p>
                      <p className="font-semibold text-dark-plum">{coverage}</p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-400 uppercase tracking-wide mb-0.5">Provider</p>
                      <p className="text-gray-600 text-sm">{provider}</p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-400 uppercase tracking-wide mb-0.5">Policy number</p>
                      <p className="text-gray-600 text-sm font-mono">{policy}</p>
                    </div>
                  </div>
                ))}
                <p className="text-sm text-gray-500 mt-2">
                  Current policy period: 6 January 2026 to 5 January 2027.
                </p>
              </div>
            </div>

            {/* TrustMark & Customer Care */}
            <div>
              <h2 className="text-2xl font-semibold text-dark-plum mb-6">TrustMark &amp; Customer Care</h2>
              <div className="space-y-5 text-gray-700">
                <div className="bg-gray-50 rounded-xl p-6 space-y-4">
                  <div>
                    <p className="font-semibold text-dark-plum mb-1">Feedback &amp; Complaints</p>
                    <p className="text-gray-600 mb-2">
                      We take customer feedback seriously. If you have a concern, please refer to our complaints procedure.
                    </p>
                    <a
                      href={complaintsPdf}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 text-primary-green font-semibold hover:underline"
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
                      </svg>
                      Download our complaints procedure
                    </a>
                  </div>

                  <div>
                    <p className="font-semibold text-dark-plum mb-1">Alternative Dispute Resolution (ADR)</p>
                    <p className="text-gray-600">
                      Our ADR provider is HIES.{' '}
                      <a
                        href="https://www.hiesscheme.org.uk/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary-green font-semibold hover:underline"
                      >
                        Visit the HIES website
                      </a>
                    </p>
                  </div>

                  <div>
                    <p className="font-semibold text-dark-plum mb-1">TrustMark Customer Charter</p>
                    <a
                      href={trustmarkCharterPdf}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 text-primary-green font-semibold hover:underline"
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
                      </svg>
                      Download the TrustMark Customer Charter
                    </a>
                  </div>

                  <div className="pt-4 border-t border-gray-200 flex justify-center">
                    <img
                      src={trustmarkLogo}
                      alt="TrustMark"
                      className="h-10 brightness-0"
                    />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  )
}

export default CustomerCare
